/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Juan Esteban Atehortua Sanchez                             ║
║ juan.atehortua@iudigital.edu.co                            ║
╚════════════════════════════════════════════════════════════╝
*/

import {
  DACIDialog,
  DACIDialogActions,
  DACIDialogContent,
  DACIDialogContentText,
  DACIDialogTitle,
} from "components/DACIDialog";
import MDButton from "components/MDButton";
import PropTypes from "prop-types";

export function RoleDelete({ openDelete, closeDelete, infoDelete, submitDelete }) {
  return (
    <>
      <DACIDialog
        open={openDelete}
        onClose={closeDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ textAlign: "center" }}
      >
        <DACIDialogTitle id="alert-dialog-title">{"¡Importante!"}</DACIDialogTitle>
        <DACIDialogContent>
          <DACIDialogContentText id="alert-dialog-description">
            ¿Está seguro de eliminar el rol: {infoDelete.name} ?
          </DACIDialogContentText>
        </DACIDialogContent>
        <DACIDialogActions>
          <MDButton onClick={closeDelete}>Cancelar</MDButton>
          <MDButton color="warning" onClick={submitDelete}>
            Eliminar
          </MDButton>
        </DACIDialogActions>
      </DACIDialog>
    </>
  );
}

RoleDelete.propTypes = {
  openDelete: PropTypes.bool,
  closeDelete: PropTypes.func,
  infoDelete: PropTypes.object,
  submitDelete: PropTypes.func,
};
